import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const GrievancePolicy = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Grievance Policy</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section id="grievance-policy">
                          <h6>1. Introduction</h6>
                          <p>
                            At {APP_INFO.companyName}, we are committed to
                            providing excellent customer service and ensuring
                            that our users' concerns and grievances are
                            addressed effectively and promptly. This Grievance
                            Redressal Policy outlines the procedure for raising
                            and resolving complaints or concerns regarding our
                            services.
                          </p>

                          <h6>2. Objective</h6>
                          <p>
                            The objective of this policy is to ensure a fair,
                            transparent, and timely resolution of user
                            grievances while maintaining the highest standards
                            of customer satisfaction.
                          </p>

                          <h6>3. Scope</h6>
                          <p>
                            This policy applies to all customers of{" "}
                            {APP_INFO.companyName}, who have availed or
                            attempted to avail any services provided by our
                            platform and have encountered any issues, concerns,
                            or dissatisfaction.
                          </p>

                          <h6>4. Grievance Categories</h6>
                          <ul>
                            <li>Failed transactions or service delays</li>
                            <li>
                              Incorrect deductions or refund-related issues
                            </li>
                            <li>Technical errors or application bugs</li>
                            <li>
                              Miscommunication or unprofessional behavior by
                              staff or agents
                            </li>
                            <li>Other service-related complaints</li>
                          </ul>

                          <h6>5. Grievance Submission Channels</h6>
                          <p>
                            Users can submit their grievances through any of the
                            following methods:
                          </p>
                          <ul>
                            <li>
                              <strong>Email:</strong> Send your complaint to{" "}
                              <a href={`mailto:${APP_INFO.grievanceEmail}`}>
                                {APP_INFO.grievanceEmail}
                              </a>
                            </li>
                            <li>
                              <strong>Support Section:</strong> Use the support
                              feature available in the {APP_INFO.companyName}{" "}
                              app
                            </li>
                            <li>
                              <strong>Customer Care:</strong> Call our helpline
                              at {APP_INFO.phone} during working hours
                            </li>
                          </ul>

                          <h6>6. Grievance Redressal Timeline</h6>
                          <ul>
                            <li>
                              Initial acknowledgment within 24 hours of
                              receiving the grievance
                            </li>
                            <li>
                              Resolution of standard complaints within 3–5
                              working days
                            </li>
                            <li>
                              In case of complex issues, resolution may take up
                              to 15 working days with regular updates to the
                              user
                            </li>
                          </ul>

                          <h6>7. Escalation Matrix</h6>
                          <p>
                            If a grievance is not resolved satisfactorily within
                            the specified timeline, users may escalate the issue
                            as follows:
                          </p>
                          <ol>
                            <li>
                              <strong>Level 1:</strong> Customer Support Team
                            </li>
                            <li>
                              <strong>Level 2:</strong> Grievance Officer –{" "}
                              <a href={`mailto:${APP_INFO.grievanceEmail}`}>
                                {APP_INFO.grievanceEmail}
                              </a>
                            </li>
                            <li>
                              <strong>Level 3:</strong> Senior Management –
                              escalated only if no resolution is provided within
                              15 working days
                            </li>
                          </ol>

                          <h6>8. User Responsibilities</h6>
                          <ul>
                            <li>
                              Provide accurate and complete information when
                              submitting a grievance
                            </li>
                            <li>
                              Keep communication channels (email/phone) open for
                              follow-up
                            </li>
                            <li>
                              Avoid misuse of the grievance mechanism by filing
                              false or misleading complaints
                            </li>
                          </ul>

                          <h6>9. Policy Review</h6>
                          <p>
                            This policy is reviewed periodically to ensure
                            continued effectiveness. Any updates will be
                            published on our website and app.
                          </p>

                          <h6>10. Contact</h6>
                          <p>
                            For any grievances, please contact our Grievance
                            Officer at{" "}
                            <a href={`mailto:${APP_INFO.grievanceEmail}`}>
                              {APP_INFO.grievanceEmail}
                            </a>
                            .
                          </p>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrievancePolicy;
